import React from 'react';
import { CircleLoader, InfinityLoader } from '@weco/ui';

// const Loader = () => <InfinityLoader />  NOTE: hidden for now but maybe we will use this again later.;
const Loader = () => <CircleLoader />;

export default Loader;
